const HN = {
  "currency-saudi": "सऊदी रियाल",

  // Buttons Labels Repeated
  "modal-ok-btn": "ठीक है",
  "modal-close-btn": "बंद करना",

  // Navbar

  "arabic-key": "अरबी",
  "english-key": "अंग्रेज़ी",
  "urdu-key": "उर्दू",
  "hindi-key": "हिन्दी",
  "main-tab": "मुख्य",
  "laundry-owners-tab": "लौंड्रोमैट",
  "Delivery-representatives-tab": "वितरण प्रतिनिधि",
  "Accountant-account-tab": "लेखांकन",
  "Earnings-account-tab": "कमाई का हिसाब",
  "admin-name": "व्यवस्थापक",
  logout: "लॉग आउट",

  // ==========================================================================================================================================
  // LogIn
  "login-form-header": "लॉग इन करें",
  "login-password-placeholder": "पासवर्ड",
  "login-btn-text": "लॉग इन करें",
  "login-user-name-placeholder": "असल में",
  // ==========================================================================================================================================
  // Copy Rights Start
  "copy-rights-start-1": "कोई सवाल है?",
  "copy-rights-start-2": "संपर्क करें",
  "copy-rights-start-3": "सफाई सेवा ऐप",
  "copy-rights-start-4": "| सर्वाधिकार सुरक्षित",
  "copy-rights-start-5": "स्टैक सॉफ्ट कंपनी द्वारा विकसित",

  // ==========================================================================================================================================
  // Main
  "statistics-main-tab": "सामान्य आँकड़े",
  "joins-requests-main-tab": "अनुरोध में शामिल हों",

  // Statistics
  "daily-done-orders-tab": "दैनिक पूर्ण आदेश",
  "payed-money-tab": "भुगतान",
  "most-used-laundry": "अधिकांश उपयोग में लाए गए लॉंड्रोमैट्स",
  "Deliverymen-header": "वितरण योग्य",
  "Laundromats-header": "लॉंड्रोमैट्स",
  "Number-of-completed-orders": "पूर्ण किए गए ऑर्डर की संख्या",
  "sort-label-statistics":
    "सबसे अधिक से कम लागू होने वाले लॉंड्रोमैट्स (पूरे किए गए ऑर्डर के आधार पर)",
  "number-of-accepted-orders": "स्वीकृत आदेशों की संख्या: ",
  "number-of-done-orders": "पूर्ण किए गए ऑर्डर की संख्या: ",
  "number-of-rejected-orders": "अस्वीकृत आदेशों की संख्या: ",

  // Join Requests
  "delivery-request-tab": "वितरण अनुरोध",
  "Laundry-Owner-request-tab": "लॉंड्रट्स स्वामी अनुरोध करते हैं",
  "accept-request": "स्वीकार करना",
  "reject-request": "अस्वीकार",
  "detail-request-button": "ऑर्डर का विवरण",
  "delivery-person-name": "डेलीवेरेमन नाम.",
  "laundry-name": "लॉन्ड्रोमैट नाम",
  "date-of-request": "आर्डर की तारीख",
  "phone-number": "फ़ोन नंबर",
  "relative-phone-number": "रिश्तेदार फोन नंबर",
  "relative-relation": "सापेक्ष संबंध",
  nationality: "राष्ट्रीयता",
  "id-or-passport": "आईडी या पासपोर्ट",
  address: "निवास का शहर",
  city: "City",
  "bulding-number": "Bulding Number",
  "floor-number": "Floor Number",
  "vehicle-type": "वाहन का प्रकार",
  "vehicle-color": "वाहन का रंग",
  "vehicle-num": "गाडी नंबर",
  "vehicle-license": "वाहन लाइसेंस",

  // ==========================================================================================================================================
  // Laundry Owners
  "date-of-join": "शामिल होने की तिथि",
  "laund-details-btn": "लॉन्ड्रोमैट विवरण",
  "all-laundries-header": "सभी लांड्राट हमसे जुड़ रहे हैं:",
  "all-laundromat-tap": "सभी लॉंड्रोमैट्स",
  "offers-free-arrive-request-tap": "नि:शुल्क वितरण आदेश",
  "offers-free-arrive-accepted-tap": "स्वीकार्य प्रस्ताव",

  // Laundry Modal
  "laundry-services-label": "लॉंड्रामेट सेवाएँ: ",
  "request-service-button": "सेवा अनुरोध",
  "services-laundry-table-column": "सेवाऍ दी गयी",
  "size-laundry-table-column": "सेवारत आकार",
  "item-type-column": "वस्तु परक",

  // Filter Laundry
  "Search-box-placeholder": "नाम या फोन नंबर से खोजें",
  "choose-city": "कोई शहर चुनें",
  "date-filter-new-to-old": "सबसे नए से लेकर सबसे पुराने तक",
  "date-filter-old-to-new": "सबसे पुराने से लेकर सबसे नए तक",

  // ==========================================================================================================================================
  // All Delivery
  "all-delivery-header": "हमारे साथ शामिल होने वाले सभी प्रतिनिधि:",
  "del-details-btn": "डेलीवेमैन का विवरण",

  // ==========================================================================================================================================
  // Earnings
  "receivables-required": "आवश्यक प्राप्य",
  "commission-due": "कमीशन नियत है",
  "the-outcome": "परिणाम",
  "outcome-zeroing": "परिणाम जेरॉलिंग",
  "info-1": "साप्ताहिक परिणाम बटन केवल शुक्रवार को चलता है.",
  "info-2":
    "डेलीवेरेमन के कारण होने वाला आयोग ही डेलीवेजरों द्वारा की जाने वाली प्रत्येक सेवा के लिए कुल आयोग है।",
  "info-3":
    "डेलीवेरेमन के लिए आवश्यक प्राप्य वे कुल कर हैं जो डेलीवेजरों को प्रत्येक सेवा के लिए प्रशासक को अदा करना आवश्यक है।",
  "info-4":
    "परिणाम, किसी धनात्मक संख्या के मामले में, वितरण करने वाले को व्यवस्थापक के लिए भुगतान करना आवश्यक है, या ऋणात्मक संख्या के मामले में, व्यवस्थापक को वितरण करने वाले के लिए भुगतान करना आवश्यक है.",
  "info-5":
    'जब व्यवस्थापक और वितरण करने वाले के बीच परिणाम जुड़ा हो, तो व्यवस्थापक को "परिणाम जेरोइंग" बटन दबाकर परिणाम को कम करना होगा.',
  "Weekly-Outcomes": "साप्ताहिक परिणाम",

  // ==========================================================================================================================================
  // Fees
  "label-1-fees":
    "कर का मूल्य एक डेलीवेरेमैन को प्रत्येक आदेश पर प्रशासक को भुगतान करना आवश्यक है:",
  "label-2-fees": "प्रत्येक 1 किमी के लिए डेलीवेजरों का कमीशन:",

  // ==========================================================================================================================================
  // Accountant
  "commissions-and-taxes-tap": "कमीशन और कर",
  "earnings-calculate-tap": "आमदनी का हिसाब होता है",

  // ==========================================================================================================================================
  // Offers Free Arrive
  "offer-det-btn": "विवरण प्रस्तुत करें",
  "categories-label-offer": "प्रस्ताव द्वारा शामिल उपयोगकर्ताओं की श्रेणियाँ:",
  "offer-time-label": "प्रस्ताव की अवधि:",
  from: "से:",
  to: "से:",
  "zeroing-cost": "जेरॉलिंग",
  cost: "लागत",
};

export default HN;
